import api from "../api";

export function fetchContactUsAction(payload) {
  return api.post(`/contactus`, {
    paramObj: payload,
  });
}
